import { useMemo } from "react";
import {useDomains} from "../hooks.js";
import  {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    useReactTable
  } from "react-table";
  
import Link from "../widgets/Link.jsx";
import { HeaderWithModal } from "../utils.jsx"

const columnHelper = createColumnHelper()

const DomainsTile = ({protein_seq_id}) => {

    const {isReady, matches} = useDomains(protein_seq_id)

    const columns = useMemo(() => [
        columnHelper.accessor(
          row => row,
          {
            id: "interpro accession",
            header: () => <span>interpro accession</span>,
            cell: info => {
                const d = info.getValue()
                if (d.signature.entry) {
                  return <Link target={"_blank"}  href={`https://www.ebi.ac.uk/interpro/entry/InterPro/${d.signature.entry.accession}`}  key={`tt-${d.signature.accession}`}  text={d.signature.entry.accession}  extraClasses={"mx-1"} />
                }
            }
          }
        ),
        columnHelper.accessor(
            row => row,
            {
              id: "source accession",
              header: () => <span>source accession</span>,
              cell: info => {
                  const d = info.getValue()
                  return d.signature.accession
              }
            }
        ),
        columnHelper.accessor(
            row => row,
            {
              id: "description",
              header: () => <span>description</span>,
              cell: info => info.getValue().signature.description
            }
        ),
        columnHelper.accessor(
            row => row,
            {
              id: "description",
              header: () => <span>library</span>,
              cell: info => {
                  const l = info.getValue().signature.signatureLibraryRelease
                  return `${l.library} ${l.version}`
              }
            }
        ),
        columnHelper.accessor(
            row => row,
            {
              id: "location",
              header: () => <span>location</span>,
              cell: info => {
                const d = info.getValue()
                if (d.locations) {
                  return  `${d.locations[0].start} - ${d.locations[0].end}`
                }
              }
            }
        ),
        columnHelper.accessor(
          row => row,
          {
            id: "score",
            header: () => <span>score</span>,
            cell: info => info.getValue().score
          }
      )
      ], [])

    const table = useReactTable({
        data: matches,
        columns,
        getCoreRowModel: getCoreRowModel()
    })

    if(!isReady) {
        return <span>...loading</span>
    }

    if(!matches) {
      return <div>No Predicted Domains</div>
    }
console.log(matches)
    return (
      <div className="shadow-[0px_0px_6px_0px_rgba(0,0,0,0.2)] mt-3 mr-3 rounded p-3">
          <div className="border-b width-full border-slate-200">
            <HeaderWithModal title="Predicted Domains">
            <p>Table of domains identified with InterProScan.</p>
            <p>Column Descriptions:</p>
                <table className="border-collapse border-t border-slate-400">
                    <tr className="border-t border-slate-300">
                        <th className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Column</th>
                        <th className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Description</th>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Interpro Accession</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">The InterProScan accession entry for
                            the match
                        </td>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Source Accession</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">The Accession of the source database of
                            the match
                        </td>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Description</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">A description to give an idea of the
                            nature of the match
                        </td>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Library</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">The interpro scan module
                        </td>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Location</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">The location of the match on the amino
                            acid sequence
                        </td>
                    </tr>
                    <tr className="border-t border-slate-300">
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Score</td>
                        <td className="pr-10 py-2 pl-1 rounded-lg text-gray-700">Domain score by InterProScan</td>
                    </tr>
                </table>
            </HeaderWithModal>
          </div>
          <table className={"w-full text-sm text-left text-gray-500"}>
              <thead className={"text-xs text-gray-700 uppercase bg-gray-50"}>
              {table.getHeaderGroups().map(headerGroup => (
                  <tr key={headerGroup.id}>
                  {headerGroup.headers.map(header => (
                  <th key={header.id} className={"px-4 py-1"}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map(row => (
              <tr key={row.id} className={"bg-white border-b hover:bg-gray-50"}>
                {row.getVisibleCells().map(cell => (
                  <td key={cell.id} className={"px-4 py-1"}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
);
}

export default DomainsTile